/**
 * This module is a fork of and modifies:
 * https://github.com/necolas/react-native-web
 *
 * The original source is (c) Nicolas Gallagher
 * and licensed under the MIT license found a
 * https://github.com/necolas/react-native-web/blob/master/LICENSE
 */

import normalizeColor from "normalize-css-color"

const processColor = (color?: string | number): number | undefined => {
  if (color === undefined || color === null) {
    return undefined
  }

  // convert number and hex
  let int32Color = normalizeColor(color)
  if (int32Color === undefined || int32Color === null) {
    return undefined
  }

  int32Color = ((int32Color << 24) | (int32Color >>> 8)) >>> 0

  return int32Color
}

export default processColor
